import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const AttachmentAltSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: SVGComponentProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...otherProps}
  >
    <path
      d="M9.33268 8.99967V5.33301C9.33268 3.86025 8.13875 2.66634 6.66602 2.66634C5.19326 2.66634 3.99935 3.86025 3.99935 5.33301V8.99967C3.99935 11.3929 5.93945 13.333 8.33268 13.333C10.726 13.333 12.666 11.3929 12.666 8.99967V2.66634H13.9994V8.99967C13.9994 12.1293 11.4623 14.6663 8.33268 14.6663C5.20307 14.6663 2.66602 12.1293 2.66602 8.99967V5.33301C2.66602 3.12387 4.45688 1.33301 6.66602 1.33301C8.87515 1.33301 10.666 3.12387 10.666 5.33301V8.99967C10.666 10.2883 9.62135 11.333 8.33268 11.333C7.04402 11.333 5.99935 10.2883 5.99935 8.99967V5.33301H7.33268V8.99967C7.33268 9.55194 7.78042 9.99967 8.33268 9.99967C8.88495 9.99967 9.33268 9.55194 9.33268 8.99967Z"
      fill={fill}
    />
  </svg>
);

export default AttachmentAltSVG;
